import React, { useState, useEffect } from 'react';
import { Card, Tag, Spin, Alert, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import {instance} from "../../../API/API";


const AvgObjectsPerDayCard = () => {
    const [data, setData] = useState({
        current: 0,
        previous: 0,
        currentWorkingDays: 0,
        previousWorkingDays: 0,
        currentTotalReports: 0,
        previousTotalReports: 0
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchAvgVisitsPerDayData();
    }, []);

    const fetchAvgVisitsPerDayData = async () => {
        try {
            setLoading(true);
            const response = await instance.get('analytics/avg_objects_per_day.php');

            if (response.data.success) {
                setData({
                    current: response.data.data.current_year,
                    previous: response.data.data.previous_year,
                    currentWorkingDays: response.data.data.current_working_days,
                    previousWorkingDays: response.data.data.previous_working_days,
                    currentTotalReports: response.data.data.current_total_reports,
                    previousTotalReports: response.data.data.previous_total_reports
                });
            } else {
                throw new Error('Invalid response format');
            }
        } catch (err) {
            console.error('Error fetching average visits per day data:', err);
            setError('Ошибка загрузки данных о среднем количестве посещений в день');
        } finally {
            setLoading(false);
        }
    };

    const calculateDifference = (current, previous) => {
        if (previous === 0) return current > 0 ? 100 : 0;
        return ((current - previous) / previous) * 100;
    };

    const getDifferenceColor = (difference) => {
        return difference >= 0 ? '#52c41a' : '#ff4d4f';
    };

    const getDifferenceIcon = (difference) => {
        return difference >= 0 ? '↗' : '↘';
    };

    if (loading) {
        return (
            <Card style={{
                height: '140px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Spin />
            </Card>
        );
    }

    if (error) {
        return (
            <Card style={{ height: '140px' }}>
                <Alert message={error} type="error" />
            </Card>
        );
    }

    const diff = calculateDifference(data.current, data.previous);

    return (
        <Card style={{
            height: '140px',
            background: 'white',
            border: '1px solid #f0f0f0',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
              bodyStyle={{
                  padding: '16px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
              }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start'
            }}>
                <div style={{ color: '#595959', fontSize: '14px', fontWeight: '500' }}>
                    Посещений объектов в среднем в день
                </div>
                <Tooltip
                    title={
                        <div>
                            <div>Всего отчетов: {data.currentTotalReports} (в этом году)</div>
                            <div>Всего отчетов: {data.previousTotalReports} (в прошлом году)</div>
                            <div>Рабочих дней: {data.currentWorkingDays} (в этом году)</div>
                            <div>Рабочих дней: {data.previousWorkingDays} (в прошлом году)</div>
                            <div>Расчет: всего отчетов ÷ рабочих дней</div>
                        </div>
                    }
                    placement="top"
                >
                    <InfoCircleOutlined style={{ color: '#8c8c8c', fontSize: '12px' }} />
                </Tooltip>
            </div>
            <div style={{ color: '#1890ff', fontSize: '28px', fontWeight: '600' }}>
                {data.current.toFixed(1)}
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: '#8c8c8c', fontSize: '12px' }}>
                    Прошлый год: {data.previous.toFixed(1)}
                </span>
                <Tag style={{
                    background: getDifferenceColor(diff),
                    border: 'none',
                    color: 'white',
                    fontSize: '11px',
                    margin: 0
                }}>
                    {getDifferenceIcon(diff)} {diff.toFixed(1)}%
                </Tag>
            </div>
        </Card>
    );
};

export default AvgObjectsPerDayCard;